import { Component } from 'lucide-react';
import React from 'react';

interface ImageCardProps {
    imagePath: string;
    title: string;
    description: string;
    iconComponent?: React.ReactNode;
    className?: string;
}

const ImageCard: React.FC<ImageCardProps> = ({
    imagePath,
    title,
    description,
    iconComponent,
    className
}) => {
    return (
        <div key={title} className={`rounded-xl border border-gray-200 shadow-sm bg-gray-100 overflow-hidden ${className}`}>
            {/* Image container */}
            <div className="m-4 p-0.5 flex justify-center items-center border-4 border-white rounded-lg">
                <img
                    src={imagePath}
                    alt={title}
                    className="w-fit lg:w-full h-auto object-contain rounded-lg"
                />
            </div>

            <div className="px-6 pb-6">
                <div className="flex items-start gap-3">
                    <div className="text-gray-600 flex-shrink-0 mt-1">
                        {iconComponent || <Component />}
                    </div>
                    <div className="font-sans text-base text-slate-500">
                        <span className="text-gray-600 mr-1 font-bold">{title}:</span>
                            {description}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageCard;